import React from "react";

const Hamburger = (props) => {
  return (
    <button {...props} className="hamburger-button">
      <div />
      <div />
      <div />
    </button>
  );
};

export default Hamburger;
